const toString = Object.prototype.toString;

export default {
  isString: function(target) {
    return toString.call(target) === '[object String]';
  },
  isArray: function(target) {
    return toString.call(target) === '[object Array]';
  },
  isNumber: function(target) {
    return toString.call(target) === '[object Number]';
  },
  isFunction: function(target) {
    return toString.call(target) === '[object Function]';
  },
  isObject: function(target) {
    return toString.call(target) === '[object Object]';
  }
};



// WEBPACK FOOTER //
// ./src/common/utils/TypeUtils.js